import { UPDropdownItem } from 'components/dropdown';

export enum EventBusinessObject {
  Employee = 1,
  Contract,
  Company,
  Dimona,
  Service,
  Wage,
}

export enum EventType {
  Create = 1,
  Read,
  Update,
  Delete,
}

export enum EventSource {
  eXpresso = 1,
  Strobbo,
  Superplanner,
  UPortal,
  Beeple,
  PublicApiV2,
}

export const EventBusinessObjectLabels = {
  [EventBusinessObject.Employee]: 'Employee',
  [EventBusinessObject.Contract]: 'Contract',
  [EventBusinessObject.Company]: 'Company',
  [EventBusinessObject.Dimona]: 'Dimona',
  [EventBusinessObject.Service]: 'Service',
  [EventBusinessObject.Wage]: 'Wage',
};

export const EventTypeLabels = {
  [EventType.Create]: 'Create',
  [EventType.Read]: 'Read',
  [EventType.Update]: 'Update',
  [EventType.Delete]: 'Delete',
};

export const EventSourceLabels = {
  [EventSource.eXpresso]: 'eXpresso',
  [EventSource.Strobbo]: 'Strobbo',
  [EventSource.Superplanner]: 'Superplanner',
  [EventSource.UPortal]: 'UPortal',
  [EventSource.Beeple]: 'Beeple',
  [EventSource.PublicApiV2]: 'Public API v2',
};

export const getEventBusinessObjectsAsDropdownItems = (): UPDropdownItem[] => {
  return [
    {
      value: EventBusinessObject.Employee,
      label: EventBusinessObjectLabels[EventBusinessObject.Employee],
    },
    {
      value: EventBusinessObject.Contract,
      label: EventBusinessObjectLabels[EventBusinessObject.Contract],
    },
    {
      value: EventBusinessObject.Service,
      label: EventBusinessObjectLabels[EventBusinessObject.Service],
    },
    {
      value: EventBusinessObject.Company,
      label: EventBusinessObjectLabels[EventBusinessObject.Company],
    },
    {
      value: EventBusinessObject.Dimona,
      label: EventBusinessObjectLabels[EventBusinessObject.Dimona],
    },
    {
      value: EventBusinessObject.Wage,
      label: EventBusinessObjectLabels[EventBusinessObject.Wage],
    },
  ];
};

export const getEventTypesAsDropdownItems = (): UPDropdownItem[] => {
  return [
    {
      value: EventType.Create,
      label: EventTypeLabels[EventType.Create],
    },
    {
      value: EventType.Read,
      label: EventTypeLabels[EventType.Read],
    },
    {
      value: EventType.Update,
      label: EventTypeLabels[EventType.Update],
    },
    {
      value: EventType.Delete,
      label: EventTypeLabels[EventType.Delete],
    },
  ];
};

export const getEventSourcesAsDropdownItems = (): UPDropdownItem[] => {
  return [
    {
      value: EventSource.eXpresso,
      label: EventSourceLabels[EventSource.eXpresso],
    },
    {
      value: EventSource.Strobbo,
      label: EventSourceLabels[EventSource.Strobbo],
    },
    {
      value: EventSource.Superplanner,
      label: EventSourceLabels[EventSource.Superplanner],
    },
    {
      value: EventSource.UPortal,
      label: EventSourceLabels[EventSource.UPortal],
    },
    {
      value: EventSource.Beeple,
      label: EventSourceLabels[EventSource.Beeple],
    },
    {
      value: EventSource.PublicApiV2,
      label: EventSourceLabels[EventSource.PublicApiV2],
    },
  ];
};
